import React from 'react';
import PropTypes from 'prop-types';
import { InputNumber, Select } from 'antd';
import { debounce } from '../../../../helpers/common.helper';
import { Flex } from '../../../shared/components';
import Text from '../../../shared/components/basic/Text';
import Box from '../../../shared/components/basic/Box';

export default function AlturaFocaInput({
  label, onChange, hide, mostrarError,
}) {
  const selectMaskStyle = { backgroundColor: 'white', height: 'inherit', padding: 0 };
  const onChangeDebounce = debounce(onChange, 350);
  return (!hide
    && (
      <div className="altura-focal" style={{ marginLeft: '8px', height: '22px' }}>
        <style>
          {'.altura-focal .ant-input-number-handler-wrap { display:none !important}'}
          {'.altura-focal .ant-input-number-input { height: inherit !important}'}
          {'.altura-focal .ant-input-number-input-wrap { line-height: 18px;}'}
          {!mostrarError && '.altura-focal .ant-input-group-addon.label { border-radius: 4px 0 0 4px !important;}'}
          {mostrarError && '.altura-focal .ant-input-group-addon.input { border-width: 1px 1px 1px 0px !important; border-radius: 0 4px 4px 0 !important; border-color: red !important;}'}
          {mostrarError && '.altura-focal .ant-input-group-addon.label { border-width: 1px 0px 1px 1px !important; border-radius: 4px 0 0 4px !important; border-color: red !important;}'}
        </style>
          {label && (
          <span
            className="ant-input-group-addon label"
            style={{
              width: 24, height: 'inherit',
            }}
          >
            <Text size="12px" lineHeight="18px">
              {label}
            </Text>
          </span>
          )}
          {!label && <span className="ant-input-group-addon" style={{ padding: 0, height: 'inherit' }} /> }
        <span className="ant-input-group-addon input" style={selectMaskStyle}>
          <InputNumber
            size="small"
            style={{ width: 50, borderColor: 'transparent', height: '20px' }}
            onChange={altura => onChangeDebounce(altura)}
          />
        </span>
      </div>
    ));
}

AlturaFocaInput.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  hide: PropTypes.bool,
  mostrarError: PropTypes.bool,
};

AlturaFocaInput.defaultProps = {
  onChange: () => {},
  hide: true,
  mostrarError: false,
  label: null,
};
